import { useFragment } from '@frameio/graphql-client';
import type { WorkspaceNavInfoFragment } from '@frameio/graphql-client/generated';
import { WorkspaceNavInfo } from '@frameio/graphql-client/generated';
import { WorkspaceAvatar } from '../../WorkspaceAvatar';
import { StyledListItemContent } from './NavItem.styles';

type WorkspaceNavItemProps = {
  workspaceId: WorkspaceNavInfoFragment['id'];
};

export function WorkspaceNavItem({ workspaceId }: WorkspaceNavItemProps) {
  const { data: workspace } = useFragment<WorkspaceNavInfoFragment, undefined>({
    fragment: WorkspaceNavInfo,
    fragmentName: 'WorkspaceNavInfo',
    from: {
      __typename: 'Workspace',
      id: workspaceId,
    },
  });

  return (
    <StyledListItemContent
      adornmentBefore={
        <WorkspaceAvatar
          alt={workspace.name ?? ''}
          avatarUrl={workspace.images?.image128}
          isWorkfront={workspace.isWorkfront ?? undefined}
          size={AVATAR_SIZE}
        />
      }
      label={workspace.name}
    />
  );
}

const AVATAR_SIZE = 20;
